
import { defineComponent, inject } from 'vue'

export default defineComponent({
  name: 'CopyLinkButton',
  props: {
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    const emitter: any = inject('emitter')

    const onClick = () => {
      emitter.emit(determineShowEventName())
    }

     function determineShowEventName() {
      return 'openCopyLinkDialog' + (props.isMobile ? 'mobile' : 'desktop')
    }

    return {
      onClick
    }
  }
})
